import React from "react";
import { BiChevronRight } from "react-icons/bi";
import { FiArrowDown } from "react-icons/fi";
import { IoIosLock } from "react-icons/io";
import Invoice from "../../Assets/invoices.png";
import stripe from "../../Assets/stripe.png";
import visa from "../../Assets/visa.svg";
import { FaRegCreditCard } from "react-icons/fa";
import moment from "moment";

const InvoicePayment = ({ cusField, invoiceList }) => {

  const getTotal = () => {
    const totalList = invoiceList.map((val) => {
      return (val.qty ? val.qty : 1) * val.price
    })

    let sum = 0
    totalList.forEach(x => sum += x);
    return sum
  }

  return (
    <>
      <div className="mt-[20px] shadow-shadow100 rounded-[8px]">
        <div className="relative h-[20px] flex justify-center items-center">
          <div className="flex gap-1 absolute left-[12px]">
            <div className="bg-[#ecf2f7] w-[8px] h-[8px] rounded-full" />
            <div className="bg-[#ecf2f7] w-[8px] h-[8px] rounded-full" />
            <div className="bg-[#ecf2f7] w-[8px] h-[8px] rounded-full" />
          </div>
          <div className="flex justify-center w-[60%] bg-[#ecf2f78f]">
            <IoIosLock className="text-[#545969] text-[12px]" />
            <h1 className="text-[7px] font-[700] text-[#0a2540]">
              invoice.stripe.com
            </h1>
          </div>
        </div>
        <div className="bg-[#f0f2f8] select-none">
          <div className="max-w-[380px] mx-auto px-[10px]">
            <h1 className="text-[16px] font-[500] pt-[46px]">abc</h1>
            <div className="bg-[#fff] p-[32px] pb-[16px] pr-[30px] mt-[26px] rounded-[12px] shadow-shadow200">
              <div>
                <div className="flex justify-between items-center">
                  <div className="w-full">
                    <h1 className="text-[#1A1A1A] text-[35px] font-[600] leading-[40px]">
                      ${getTotal()}.00
                    </h1>
                    <p className="text-[#7A7A7A] text-[14px] font-[500] pb-[10px] mb-[10px]">
                      Due {moment(Date()).format("MMMM DD, yyyy")}
                    </p>
                  </div>
                  <div className="relative">
                    <img
                      src={Invoice}
                      alt="Invoice"
                      className="w-[131px] mr-[18px]"
                    />
                    <button className="w-[25px] h-[25px] bg-white absolute bottom-[10px] right-[6px] shadow-shadow300 flex justify-center items-center rounded-full">
                      <FiArrowDown className="text-[#7A7A7A]" />
                    </button>
                  </div>
                </div>
                <div>
                  <table className="text-[14px] mt-[12px]">
                    <tbody>
                      <tr>
                        <td className="text-[#7A7A7A]">To</td>
                        <td className="w-[20px]"></td>
                        <td className="text-[#1A1A1A]">{cusField.name}</td>
                      </tr>
                      <tr>
                        <td className="text-[#7A7A7A]">From</td>
                        <td className="w-[20px]"></td>
                        <td className="text-[#1A1A1A]">abc</td>
                      </tr>
                      <tr>
                        <td className="text-[#7A7A7A] pb-[10px]">Invoice</td>
                        <td className="w-[20px] pb-[10px]"></td>
                        <td className="text-[#1A1A1A] pb-[10px]">#</td>
                      </tr>
                      <tr>
                        <td></td>
                        <td className="w-[20px]"></td>
                        <td className="text-[#1a1a1a80] text-[12px] border-t-[1px] border-t-[#aaa3] pt-[10px] flex items-center font-[500]">
                          View invoice and payment details{" "}
                          <BiChevronRight className="text-[20px]" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="bg-[#fff] p-[32px] pr-[30px] pb-[24px] mt-[26px] rounded-[12px] shadow-shadow200">
              <p className="text-[#1a1a1ae6] text-[20px] font-[500]">
                Pay with card
              </p>
              <div className="mt-[16px]">
                <p className="text-[#1a1a1ab3] text-[13px] font-[500]">
                  Card information
                </p>
                <div className="text-[#1a1a1ae6] mt-1">
                  <div className="relative">
                    <input
                      type="text"
                      value="4242 4242 4242 4242"
                      className="text-[14px] shadow-shadow400 outline-none w-full p-[8px_12px] rounded-t-[6px]"
                    />
                    <img
                      src={visa}
                      alt="visa"
                      className="w-[24px] absolute right-[14px] top-[50%] translate-y-[-50%]"
                    />
                  </div>
                  <div className="flex">
                    <div>
                      <input
                        type="text"
                        value="12 / 24"
                        className="text-[14px] shadow-shadow400 outline-none w-full p-[8px_12px] rounded-bl-[6px] z-[1] relative"
                      />
                    </div>
                    <div className="relative">
                      <input
                        type="text"
                        value="123"
                        className="text-[14px] shadow-shadow400 outline-none w-full p-[8px_12px] rounded-br-[6px]"
                      />
                      <div>
                        <FaRegCreditCard className="w-[24px] absolute right-[14px] top-[50%] translate-y-[-50%] opacity-[.5]" />
                        <div className="bg-[#000a] text-white w-[10px] h-[10px] rounded-full text-[4px] flex justify-center items-center font-[600] absolute right-[11px] top-[7px]">
                          135
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button className="bg-[#0074d4] text-white w-full rounded-[6px] h-[44px] mt-[24px] text-[14px] relative">
                  Pay ${getTotal()}.00
                  <IoIosLock className="absolute right-[10px] top-[50%] translate-y-[-50%] text-[18px]" />
                </button>
                <p className="text-[#1a1a1a99] text-[11px] mt-[16px]">
                  By confirming your payment, you allow abc to charge your card
                  for this payment and future payments in accordance with their
                  terms.
                </p>
              </div>
            </div>
            <div className="text-[#aaa] text-[12px] flex justify-center items-center mt-[30px] pb-[10px]">
              <p>Powered by</p>
              <img
                src={stripe}
                alt="stripe"
                className="w-[40px] opacity-[.4]"
              />
            </div>
            <div className="text-[#1a1a1a80] text-[11px] flex justify-center items-center pb-[50px] gap-3">
              <button className="border-dotted border-b-[1px] border-b-[#aaa]">
                Terms
              </button>
              <button className="border-dotted border-b-[1px] border-b-[#aaa]">
                Privacy
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoicePayment;
